import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_TRAVEL_API_BASE_URL;

export interface FlightsPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface FlightsResponse<T = any> {
  items: T[];
  pagination?: FlightsPagination;
}

export const fetchFlights = async (
  from: string,
  to: string,
  targetDate: string,
  travellers?: { adults?: number; children?: number; infants?: number },
  cabinClass?: number
): Promise<FlightsResponse> => {
  const res = await fetch(`${API_BASE_URL}/flights/search`, {
    method: 'POST',
    headers: getApiHeaders('json'),
    body: JSON.stringify({
      from,
      to,
      departureDate: targetDate,
      adults: travellers?.adults ?? 1,
      children: travellers?.children ?? 0,
      infants: travellers?.infants ?? 0,
      cabinClass: cabinClass ?? 1,
    }),
  });

  if (!res.ok) throw new Error('Failed to fetch flights');

  return res.json();
};
